import {Env} from './Env';
import {proxyApp} from '~env/proxy';
import {adds} from '~env/adds';
import {mqttApp} from '~env/mqtt';

export const environment: Env = {
  production: true,
  description: 'Test Environment',
  proxy: {
    ...proxyApp,
    controlTower: 'https://api-monitoramento.sistemamobiis.com.br/api',
    imageApi: 'https://ewvkszf2b6.execute-api.sa-east-1.amazonaws.com/image',
  },
  experimentalFeatures: {
    showChat: false,
  },
  mqtt: {...mqttApp},
  adds,
};
